import { firebase, disconnectDb } from 'app-modules/application/utils/firebase';
import { LOAD_ANSWER } from './types';

export const triviaLoadAnswerActionThunk = (triviaId) => async (dispatch, getState) => {
  try {
    const {
      device: { ID: deviceID },
    } = getState();
    await dispatch({ type: LOAD_ANSWER.REQUEST });

    const db = firebase.database();
    const triviaAnswerSnapshot = await db.ref(`/answers/${triviaId}/${deviceID}`).once('value');

    if (triviaAnswerSnapshot.exists()) {
      const answer = triviaAnswerSnapshot.val();

      await dispatch({ type: LOAD_ANSWER.SUCCESS, payload: { triviaId, answer } });
    }
  } catch (err) {
    await dispatch({ type: LOAD_ANSWER.FAILURE, payload: err, error: true });
  } finally {
    disconnectDb();
  }
};
